module.exports = __webpack_public_path__ + "6eb2e862e8aba3e0428cbce67fa61406.jpg";